<template>
  <div id = "rules">
		<rule v-for="(item, index) in rules" :key="index" :rule="item" class = "column"></rule>
  </div>
</template>

<script>
  // import rules from '@/assets/resources/rules.js'
  import rule from '@/components/registration-components/Rule'
 
  
  export default{
    components: {
      rule
    },
    props: [
      'rules'
    ],
    data () {
      return {
      }
    }
  }
</script>

<style lang="scss" scoped>
	#rules {
    height: 100%;
    padding-top: 50px;
	}

	.title{
		font-weight: bold;
		font-size: 58px;
    text-align: center;
	}
</style>